const namespace = 'managers'

export const loadingSelector = state => {
  return state[namespace].get('fetching')
}

export const entriesSelectors = state => {
  return state[namespace].get('entries')
}

export const totalSelector = state => {
  return state[namespace].get('total')
}

export const getGroupManagerSelector = state => {
  return state[namespace].get('group_manager')
}